import React, { useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import HoldingsPopUp from './holdingsPopUp ';

export default function ApexChart({ top5Holdings }) {
  console.log("🚀 ~ ApexChart ~ top5Holdings:", top5Holdings)
  const [series] = useState([{
    data: top5Holdings?.serise ? top5Holdings.serise.map(value => Number(value)) : []
  }]);
  const labels = top5Holdings?.options || [];
  const [showPopUp, setShowPopUp] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [options] = useState({
    chart: {
      type: 'bar',
      events: {
        click: function (event, chartContext, config) {
          console.log('Chart clicked:', config);  // Logging config object for debugging
          const dataPointIndex = config.dataPointIndex; // Get index of the clicked data
          if (dataPointIndex !== -1) {
            const label = labels[dataPointIndex]; // Get the label for the clicked bar
            const value = series[0].data[dataPointIndex]; // Get the value for the clicked bar

            // Log the data for debugging purposes
            console.log(`Clicked label: ${label}, value: ${value}`);

            // Set selected data and show the pop-up
            setSelectedData({ label, value });
            setShowPopUp(true); // Show the pop-up
          } else {
            console.log('Click not on a data point');
          }
        },
      },
      toolbar: {
        show: false // Hide the toolbar
      }
    },
    dataLabels: {
      enabled: true,  // Enable data labels
      style: {
        colors: ['#000'],  // Set text color to black
        fontSize: '14px',  // Adjust font size if needed
        fontWeight: 'bold',
      }
    },
    plotOptions: {
      bar: {
        horizontal: false, // Vertical bar chart
        distributed: true, // Distribute colors
        columnWidth: '60px', // Adjust this value as needed
        endingShape: 'rounded', // Apply rounded ends to the bars
        borderRadius: 8,// Set the border-radius for the bars
        borderRadiusApplication: 'end'
      }
    },
    xaxis: {
      // categories: ['FIRST MILLING CO', 'ADNOC GAS PLC', 'SAL SAUDI LOGISTICS', 'DUBAI ELECTRICITY AND WATER AU', 'ADNOC LOGISTICS AND SERVICES'], // X-axis categories
      categories: labels,
      labels: {
        show: false // Show x-axis labels
      },
      title: {
        text: undefined // Hide x-axis title
      }
    },
    yaxis: {
      labels: {
        show: false // Show y-axis labels
      },
      title: {
        text: undefined // Hide y-axis title
      }
    },
    colors: ['#1d3b6f', '#a4906b', '#4a4c55', '#63366e', '#a9333a', '#006b68', '#006394', '#6f7197', '#c3b59b', '#828189', '#bf8486', '#bf8486', '#769a98', '#6d94b5'],
    legend: {
      position: 'bottom',
      horizontalAlign: 'left',
      fontSize: '12px',
      fontFamily: "Montserrat SemiBold",
      color: "#000"
    },
    tooltip: {
      // Disable or customize tooltip
      enabled: false, // Set to false to disable tooltip
    },
    responsive: [{
      breakpoint: 992,
      options: {
        chart: {
          // width: "100%"
          height: "400px"
        },
        legend: {
          position: 'bottom',
          horizontalAlign: 'left',
          fontSize: '12px'
        },
      },
    }, {
      breakpoint: 570,
      options: {
        plotOptions: {
          bar: {
            columnWidth: '30px', // Adjust this value as needed
          }
        },
      },

    }]
  });

  return (
    <div>
      <div id="chart">
        <ReactApexChart options={options} series={series} type="bar" />
      </div>
      <div id="html-dist"></div>
    </div>
  );
}
